/* eslint import/no-cycle: 0 */
import React from 'react'
import { Rating } from 'react-simple-star-rating'

import { StarFeedbackProps } from './props'
import { Container, Question, RatingWrapper } from './styles'

const StarFeedback = ({ assessment }: StarFeedbackProps) => (
  <Container key={assessment.id}>
    <Question>{assessment.question}</Question>
    <RatingWrapper>
      <span>{(assessment.sum / assessment.amount).toFixed(1).replace('.', ',')}</span>
      <Rating
        readonly
        allowFraction
        initialValue={assessment.sum / assessment.amount}
        size={18}
      />
    </RatingWrapper>
  </Container>
)

export default StarFeedback
